function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,47.843137%,80%)",
      fillOpacity: 1
    },
    d: "M 10.261719 38 L 10.261719 65.738281 L 65.738281 65.738281 L 65.738281 10.261719 L 10.261719 10.261719 Z M 10.261719 38 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.527344 38.183594 L 22.511719 40.445312 L 29.746094 40.445312 L 29.746094 60.96875 L 34.855469 60.96875 L 34.855469 40.445312 L 42.074219 40.445312 L 42.074219 38.210938 C 42.074219 36.980469 42.042969 35.949219 42.011719 35.917969 C 41.980469 35.886719 37.589844 35.871094 32.269531 35.871094 L 22.570312 35.902344 Z M 22.527344 38.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.023438 35.855469 C 56.4375 36.207031 57.5 36.828125 58.488281 37.863281 C 59.007812 38.410156 59.75 39.398438 59.8125 39.640625 C 59.828125 39.71875 57.410156 41.328125 55.953125 42.242188 C 55.90625 42.269531 55.691406 42.042969 55.449219 41.695312 C 54.734375 40.660156 53.992188 40.203125 52.851562 40.128906 C 51.164062 40.007812 50.085938 40.886719 50.097656 42.363281 C 50.097656 42.789062 50.160156 43.046875 50.34375 43.394531 C 50.707031 44.15625 51.40625 44.628906 53.550781 45.554688 C 57.515625 47.257812 59.21875 48.398438 60.28125 49.992188 C 61.46875 51.785156 61.726562 54.628906 60.921875 56.757812 C 60.039062 59.066406 57.851562 60.632812 54.78125 61.148438 C 53.824219 61.316406 51.574219 61.285156 50.554688 61.105469 C 48.320312 60.707031 46.207031 59.613281 44.914062 58.15625 C 44.398438 57.59375 43.410156 56.117188 43.472656 56.011719 C 43.503906 55.980469 43.730469 55.828125 43.988281 55.691406 C 44.230469 55.554688 45.175781 55.007812 46.054688 54.507812 L 47.652344 53.578125 L 47.988281 54.066406 C 48.457031 54.78125 49.476562 55.753906 50.085938 56.089844 C 51.847656 57.015625 54.277344 56.894531 55.480469 55.8125 C 55.996094 55.34375 56.210938 54.855469 56.210938 54.15625 C 56.210938 53.519531 56.132812 53.230469 55.800781 52.742188 C 55.375 52.121094 54.492188 51.605469 51.984375 50.523438 C 49.125 49.292969 47.894531 48.519531 46.753906 47.316406 C 46.101562 46.617188 45.492188 45.476562 45.234375 44.550781 C 45.023438 43.761719 44.976562 41.800781 45.144531 41.007812 C 45.738281 38.242188 47.820312 36.3125 50.828125 35.75 C 51.800781 35.554688 54.066406 35.613281 55.023438 35.855469 Z M 55.023438 35.855469 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.143a84497ddcf755a5bd37ca064d6748.svg";
export { ForwardRef as ReactComponent };